<script>
import EnvironmentUtils from '@/utils/environmentUtils'
import LoadingBar from '@/components/LoadingBar'
import EventsUtils from '@/utils/eventsUtils'
import ParticlesUtils from '@/utils/particlesUtils'

export default
{
    name: 'splashscreen',

    props:
    {
        animationTimeout: { type: Number, default: 0 }
    },

    render () 
    {
        return (
            <div id='splashscreen-view'>
                <div id='background' />
                <div id='city-name'>{ EnvironmentUtils.cityName }</div>
                <loading-bar progress={this.loadingBarProgress} particles={true} />
                <div ref='particlesSpawn' id='particles-spawn' />
                <div id='client-credit'>Cette application vous est offerte par {EnvironmentUtils.clientName}.</div>
            </div>
        )
    },

    data () 
    {
        return {
            loadingBarProgress: 0,
            animateInterval: null
        }
    },

    mounted ()
    {
        setTimeout(() =>
        {
            this.$el.classList.add('start-animation')
            this.animateInterval = setInterval(this.animate, 100)
        }, this.animationTimeout)

        const randomLoadingBarIncrement = () =>
        {
            if (this.loadingBarProgress == 1) return

            this.loadingBarProgress += Math.random() / 3
            setTimeout(() =>
            {
                if (!this.$el) return

                randomLoadingBarIncrement()
            }, Math.random() * 1000);
        }
        randomLoadingBarIncrement()


        EventsUtils.onSplashscreenHidding().then(() => this.loadingBarProgress = 1)
    },

    beforeDestroy ()
    {
        if (this.animateInterval) clearInterval(this.animateInterval)
    },

    methods:
    {
        animate ()
        {
            var specialDateText = ''
            const now = new Date()
            if ((now.getMonth() == 11 && now.getDay() == 31) || (now.getMonth() == 0 && now.getDay() == 1)) specialDateText = ['🎉', '🎊']
            else if (now.getMonth() == 11) specialDateText = '❄'
            else if (now.getMonth() == 9 && now.getDay() > 25) specialDateText = ['🎃', '🦇']
            else if (now.getMonth() == 6 && (now.getDay() >= 13 && now.getDay() <= 15)) specialDateText = '🇫🇷'

            if (specialDateText)
            {
                ParticlesUtils.createParticle({y: 0, x:[-400, window.innerWidth + 400], destinationY: window.innerHeight + 100, text: specialDateText, duration: 4000,
                    size: [40, 50], color: 'white', opacity: {from: 1, to: 0.5}})
            }
        }
    },

    components:
    {
        LoadingBar
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#splashscreen-view
{
    position: fixed;
    z-index: 5;
    background: var(--theme-accent-color);
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;


    &.start-animation
    {
        #background
        {
            opacity: 1;
            transition: opacity 1s linear;
        }

        #city-name
        {
            opacity: 1;
            animation: fadeIn 1s;
        }
    }

    > #background
    {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        .WidthHeight(100%);
        background: linear-gradient(0deg, var(--theme-splashscreen-top-color), var(--theme-splashscreen-bottom-color));
    }

    > #city-name
    {
        opacity: 0;
        z-index: 5;
        position: absolute;
        top: 35vh;
        text-align: center;
        font-size: 10vw;
        font-weight: bolder;
        font-family: Nunito;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.6), 1px 0px 1px rgba(0, 0, 0, 0.3);

        .OnDesktop({ font-size: 6vh; });
    }

    .loading-bar
    {
        margin: 0 10px;
        height: 3.5px;

        .OnDesktop({ margin: 0 80px; });

        .foreground
        {
            background-color: white;
        }
    }

    > #particles-spawn
    {
        position: absolute;
        top: 50vh;
    }

    > #client-credit
    {
        text-align: center;
        position: fixed;
        bottom: 3vh;
        font-size: 12px;
        width: 90vw;
        opacity: 0.4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Splashscreen.vue